var $5edd453ae5d4a8bc$exports = {};
$5edd453ae5d4a8bc$exports = {
  "dragDescriptionKeyboard": "Pressione Enter para come\xE7ar a arrastar.",
  "dragDescriptionKeyboardAlt": "Pressione Alt + Enter para come\xE7ar a arrastar.",
  "dragDescriptionLongPress": "Pressione e segure para come\xE7ar a arrastar.",
  "dragDescriptionTouch": "Toque duas vezes para come\xE7ar a arrastar.",
  "dragDescriptionVirtual": "Clique para come\xE7ar a arrastar.",
  "dragItem": function dragItem(args) {
    return "Arrastar ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Arrastar ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " item selecionado");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " itens selecionados");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Pressione Enter para arrastar ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " o item selecionado");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " os itens selecionados");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Pressione Alt + Enter para arrastar ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " o item selecionado");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " os itens selecionados");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Pressione e segure para arrastar ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " o item selecionado");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " os itens selecionados");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Comece a arrastar. Pressione Tab para navegar at\xE9 um alvo e, em seguida, pressione Enter para soltar ou pressione Escape para cancelar.",
  "dragStartedTouch": "Comece a arrastar. Navegue at\xE9 um alvo e toque duas vezes para soltar.",
  "dragStartedVirtual": "Comece a arrastar. Navegue at\xE9 um alvo e clique ou pressione Enter para soltar.",
  "dropCanceled": "Libera\xE7\xE3o cancelada.",
  "dropComplete": "Libera\xE7\xE3o conclu\xEDda.",
  "dropDescriptionKeyboard": "Pressione Enter para soltar. Pressione Escape para cancelar.",
  "dropDescriptionTouch": "Toque duas vezes para soltar.",
  "dropDescriptionVirtual": "Clique para soltar.",
  "dropIndicator": "indicador de libera\xE7\xE3o",
  "dropOnItem": function dropOnItem(args) {
    return "Soltar em ".concat(args.itemText);
  },
  "dropOnRoot": "Soltar",
  "endDragKeyboard": "Arrastando. Pressione Enter para cancelar.",
  "endDragTouch": "Arrastando. Toque duas vezes para cancelar.",
  "endDragVirtual": "Arrastando. Clique para cancelar.",
  "insertAfter": function insertAfter(args) {
    return "Inserir ap\xF3s ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Inserir antes de ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Inserir entre ".concat(args.beforeItemText, " e ").concat(args.afterItemText);
  }
};
export { $5edd453ae5d4a8bc$exports as default };